import React, { useState } from 'react';
import type { FC, ReactNode } from 'react';
import type { i18n } from 'i18next';
import { I18nextProvider } from 'react-i18next';
import { createI18n } from './create-i18n.js';

interface PropsWithMessages {
  children: ReactNode;
  messages: Record<string, string>;
  i18n?: never;
}

interface PropsWithI18n {
  children: ReactNode;
  i18n: i18n;
  messages?: never;
}

export const I18nProvider: FC<PropsWithMessages | PropsWithI18n> = ({
  children,
  messages,
  i18n: initialI18n,
}) => {
  const [i18n] = useState(() => initialI18n ?? createI18n(messages));

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};
